import { ValidationFormComponent } from './components';

/**
 * Wrapper for the Advanced Validation Form Example.
 *
 * This component demonstrates a variety of complex validation scenarios,
 * including regex patterns, custom functions, and numeric ranges.
 * It has been refactored to use a single, consolidated `useValidationForm`
 * hook and adopts the standardized, modern styling.
 *
 * Key features demonstrated:
 * - Real-time validation dashboard with metrics.
 * - Complex validation rules (email, password strength, age, etc.).
 * - Simplified and bug-free hook implementation.
 * - Consistent and modern UI/UX.
 */
export const ValidationFormWrapper = ValidationFormComponent; 